<template>
  <div class="col-12 gift-cart-contents">
    <adv-cart-gift-row
      v-for="(cartProduct, index) in cartProductContents"
      :key="index"
      :mini-cart="miniCart"
      :cart-product="cartProduct"></adv-cart-gift-row>
  </div>
</template>

<script>
import store from '../../vue/store'
import AdvCartGiftRow from './AdvCartGiftRow'

export default {
  name: 'AdvCartGiftList',
  components: {
    AdvCartGiftRow
  },
  props: {
    miniCart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    cartProductContents () {
      return store.getters.giftContents
    }
  }
}
</script>
